var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    [
      _c("gg-card-header", [
        _vm._v(" Migration #" + _vm._s(_vm.migration.id) + " ")
      ]),
      _c(
        "gg-card-text",
        [
          _c("v-simple-table", {
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function fn() {
                  return [
                    _c("thead", [
                      _c("tr", [
                        _c(
                          "th",
                          {
                            staticClass: "text-left"
                          },
                          [_vm._v(" Service ")]
                        ),
                        _c(
                          "th",
                          {
                            staticClass: "text-left"
                          },
                          [_vm._v(" Status ")]
                        ),
                        _c(
                          "th",
                          {
                            staticClass: "text-left"
                          },
                          [_vm._v(" Event title ")]
                        ),
                        _c(
                          "th",
                          {
                            staticClass: "text-left"
                          },
                          [_vm._v(" Source ")]
                        ),
                        _c(
                          "th",
                          {
                            staticClass: "text-left"
                          },
                          [_vm._v(" Destination ")]
                        )
                      ])
                    ]),
                    _c("tbody", [
                      _c("tr", [
                        _c("td", [
                          _vm._v(" " + _vm._s(_vm.migration.service_name) + " ")
                        ]),
                        _c("td", [
                          _vm._v(" " + _vm._s(_vm.migration.status) + " ")
                        ]),
                        _c("td", [
                          _vm._v(" " + _vm._s(_vm.migration.event_title) + " ")
                        ]),
                        _c("td", [
                          _vm._v(
                            " " + _vm._s(_vm.migration.source_server) + " "
                          )
                        ]),
                        _c("td", [
                          _vm._v(
                            " " + _vm._s(_vm.migration.destination_server) + " "
                          )
                        ])
                      ])
                    ])
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }